import { useState } from "react";
import { Alert, Box, Button, Card, CardContent, Divider, Stack, TextField, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { api } from "../../api/client";
import { useAuth } from "../../api/auth-context";

/** Perfil do usuário: dados básicos (read-only) + troca da própria senha.
 *  Acessível pelo menu "Perfil" (AppShell do design-system) em todos os módulos. */
export function ProfilePage() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [ok, setOk] = useState(false);

  const changeM = useMutation({
    mutationFn: () => api.post("/auth/password/change", { currentPassword: current, newPassword: next }),
    onSuccess: () => { setOk(true); setCurrent(""); setNext(""); setConfirm(""); },
  });

  const mismatch = confirm.length > 0 && next !== confirm;
  const tooShort = next.length > 0 && next.length < 10;
  const canSubmit = !!current && next.length >= 10 && next === confirm && !changeM.isPending;
  const errMsg = (changeM.error as { response?: { data?: { message?: string } } } | null)?.response?.data?.message;

  return (
    <Box sx={{ maxWidth: 560 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Perfil</Typography>

      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="subtitle2" color="text.secondary">Dados</Typography>
          <Stack spacing={1} sx={{ mt: 1 }}>
            <TextField label="Nome" value={user?.name ?? ""} InputProps={{ readOnly: true }} fullWidth size="small" />
            <TextField label="Email" value={user?.email ?? ""} InputProps={{ readOnly: true }} fullWidth size="small" />
          </Stack>
        </CardContent>
      </Card>

      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" color="text.secondary">Trocar senha</Typography>
          <Divider sx={{ my: 1 }} />
          <Stack
            component="form"
            spacing={2}
            sx={{ mt: 1 }}
            onSubmit={(e) => { e.preventDefault(); if (canSubmit) changeM.mutate(); }}
          >
            {ok && <Alert severity="success" onClose={() => setOk(false)}>Senha alterada com sucesso.</Alert>}
            {changeM.isError && <Alert severity="error">{errMsg ?? "Não foi possível alterar a senha."}</Alert>}
            <TextField label="Senha atual" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} fullWidth autoComplete="current-password" />
            <TextField
              label="Nova senha" type="password" required value={next} onChange={(e) => setNext(e.target.value)} fullWidth autoComplete="new-password"
              error={tooShort} helperText={tooShort ? "Mínimo de 10 caracteres" : "Mínimo de 10 caracteres"}
            />
            <TextField
              label="Confirmar nova senha" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} fullWidth autoComplete="new-password"
              error={mismatch} helperText={mismatch ? "As senhas não conferem" : " "}
            />
            <Box>
              <Button type="submit" variant="contained" disabled={!canSubmit}>Alterar senha</Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
